import { get } from 'lodash-es';

import { isFormValuePresent } from '../../components/forms/formHelpers';

export function formToInputAddress(form) {
  return {
    addressLine1: get(form, 'addressLines[0]'),
    addressLine2: get(form, 'addressLines[1]'),
    addressLine3: get(form, 'addressLines[2]'),
    postalCode: form?.postalCode,
    city: form?.city,
    stateProvince: form?.stateProvince,
    country: form?.country,
  };
}

export function formToInputFlight(form) {
  const { flight, airwayBillNumber } = form || {};
  const {
    airline,
    flightNumber,
    arrivalDatetime,
    arrivalAirport,
    departureDatetime,
    departureAirport,
  } = flight || {};

  return {
    airline,
    flightNumber,
    origin: departureAirport,
    destination: arrivalAirport,
    departureDatetime,
    arrivalDatetime,
    awb: airwayBillNumber,
  };
}

export function formToInputJobLocation(form) {
  return {
    companyName: form?.companyName,
    contact: {
      name: form?.contact?.name,
      email: form?.contact?.email,
      phone: form?.contact?.phone,
      phoneExtension: form?.contact?.phoneExtension,
    },
    address: formToInputAddress(form?.address),
    specialInstructions: form?.specialInstructions || '',
  };
}

export function graphQLToFormJobLocation(data) {
  const { companyName, contact, address, specialInstructions } = data || {};
  return {
    companyName,
    contact: {
      name: contact?.name,
      email: contact?.email,
      phone: contact?.phone,
      phoneExtension: contact?.phoneExtension,
    },
    address: {
      addressLines: [
        address?.addressLine1,
        address?.addressLine2,
        address?.addressLine3,
      ].filter(isFormValuePresent),
      postalCode: address?.postalCode,
      city: address?.city?.text,
      stateProvince:
        address?.stateProvince?.text || address?.stateProvince?.code,
      country: address?.country?.text || address?.country?.code,
    },
    specialInstructions,
  };
}
